
import React from "react";
import { withStyles, createStyles } from "@material-ui/core";

const styles = () =>
  createStyles({
    textPhone: {
      color: "#0256A8"
    }
  });

const phone = ({ classes, tel, textPhone }) => {
  return <a href={`tel:${tel}`} className={classes.textPhone}>{textPhone}</a>;
}
export const Phone = withStyles(styles)(phone);
